import React, { useState } from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import './styles.css';

export default function DateRangeInput({ handleChange, selectRange }) {
  const [value, onChange] = useState(new Date());

  const handDate = (newValue) => {
    onChange(newValue);
    handleChange(newValue)
  };
  return (
    <div>
      <Calendar onChange={handDate} current={value} selectRange={selectRange} minDate={new Date()} />
    </div>
  );
}